import type { PayloadAction } from '@reduxjs/toolkit';

import { checkArraysContainSameItems } from 'shared/lib';
import type { TGroupItemCategory } from 'shared/types/TRankingService';

import type { IOffersState } from 'entities/offers';

export const disableOffersByCategoryAndPledgeReducer = (
  state: IOffersState,
  action: PayloadAction<{
    offerId: string;
    bankId: string;
    category: TGroupItemCategory;
    rawPledgeList: string[];
  }>,
) => {
  const { offerId, bankId, rawPledgeList, category } = action.payload;

  state.offers = state.offers.filter((offer) => {
    if (
      offer.id !== offerId &&
      offer.bankId === bankId &&
      offer.category === category &&
      !offer.additionalInfo?.isReferral &&
      checkArraysContainSameItems(rawPledgeList, offer.additionalInfo?.rawPledgeList)
    ) {
      return false;
    }
    return true;
  });
};
